import { useState } from "react";

interface Props {
  text: string;
  label?: string;
  onCopy?: () => void;
}

export function CopyButton({ text, label = "Kopiuj", onCopy }: Props) {
  const [copied, setCopied] = useState(false);

  async function handle() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      onCopy?.();
      setTimeout(() => setCopied(false), 1400);
    } catch {
      // Fallback: select+copy via temporary textarea (older Safari).
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        onCopy?.();
        setTimeout(() => setCopied(false), 1400);
      } finally {
        ta.remove();
      }
    }
  }

  return (
    <button type="button" className={`copy-btn ${copied ? "copied" : ""}`} onClick={handle}>
      {copied ? "✓" : label}
    </button>
  );
}
